import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Recaptcha = forwardRef(({ onChange }, ref) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!siteKey) {
    console.error('REACT_APP_RECAPTCHA_SITE_KEY não configurada — reCAPTCHA não será exibido');
    return null;
  }

  return (
    <div className="mb-3">
      <ReCAPTCHA ref={ref} sitekey={siteKey} onChange={onChange} onExpired={() => onChange(null)} />
    </div>
  );
});

Recaptcha.displayName = 'Recaptcha';

export default Recaptcha;
